module.exports = __webpack_public_path__ + "img/master_delivery.8e985f70.svg";